import React, { FC, useCallback } from 'react'
import styles from 'styles/components/modal.module.scss'
import { useDispatch, useSelector } from 'react-redux'
import { State } from 'index'
import { getConfirmModalOpen } from 'reducks/modal/selectors'
import { ConfirmModalTitle } from './index'
import { Spacer } from 'components/Utility'
import { Description } from 'components/Typography'
import { FlexRow } from 'components/Flex'
import { BlueButton, CautionButton, GreyButton } from 'components/Button'
import { closeConfirmModal, closeModal } from 'reducks/modal/operations'

type Props = {
  cautionActionLabel?: string
  cancelActionLabel?: string
  dataCy?: string
  description?: string
  title?: string
  actionButtonColor?: 'caution' | 'blue'
  onClose?: () => void
}

const ConfirmModal: FC<Props> = (props) => {
  const {
    cautionActionLabel = '破棄する',
    cancelActionLabel = 'キャンセル',
    dataCy,
    description = '修正した内容が破棄されますが、よろしいでしょうか？',
    title = '修正内容の破棄',
    actionButtonColor = 'caution',
    onClose,
  } = props
  const confirmOpen = useSelector((state: State) => getConfirmModalOpen(state))
  const dispatch = useDispatch()

  const closeConfirmModalCallback = useCallback(() => dispatch(closeConfirmModal()), [dispatch])
  const closeModalCallback = useCallback(() => {
    dispatch(closeModal())
    onClose?.()
  }, [dispatch, onClose])

  const dataCyStr = dataCy ? `confirm-modal-from-${dataCy}` : 'confirm-modal'

  return (
    <div className={confirmOpen ? styles.confirm_open : ''}>
      <div className={styles.confirm__overlay}>
        <div
          className={styles.confirm__background}
          data-cy={'confirm-modal-background'}
          onClick={closeConfirmModalCallback}
        />
        {confirmOpen && (
          <div className={styles.confirm__container} data-cy={dataCyStr}>
            <ConfirmModalTitle title={title} />
            <Spacer size={16} />
            <Description description={description} />
            <Spacer size={20} />
            <FlexRow justifyContent={'center'}>
              <GreyButton
                dataCy={'confirm-modal'}
                label={cancelActionLabel}
                onClick={closeConfirmModalCallback}
                size={'small'}
                type={'outlined'}
              />
              <Spacer size={24} axis={'horizontal'} />
              {actionButtonColor === 'blue' ? (
                <BlueButton label={cautionActionLabel} onClick={closeModalCallback} size={'small'} type={'main'} />
              ) : (
                <CautionButton
                  dataCy={'confirm-modal'}
                  label={cautionActionLabel}
                  onClick={closeModalCallback}
                  size={'small'}
                />
              )}
            </FlexRow>
          </div>
        )}
      </div>
    </div>
  )
}

export default ConfirmModal
